module.exports = __webpack_public_path__ + "static/media/icon-event__transicion-espanola.b6b119d5.svg";